(function () {
  var ROOT_SELECTOR = '[data-all-brands-root]';
  var SEARCH_SELECTOR = '[data-all-brands-search]';

  function normalize(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  function AllBrandsPage(root) {
    this.root = root;
    this.cards = Array.prototype.slice.call(root.querySelectorAll('[data-brand-card]'));
    this.groups = Array.prototype.slice.call(root.querySelectorAll('[data-brand-group]'));
    this.emptyState = root.querySelector('[data-brand-empty]');
    this.letterButtons = Array.prototype.slice.call(root.querySelectorAll('[data-brand-letter-filter]'));
    this.activeLetter = 'all';
    this.searchQuery = '';
    this.bindEvents();
    this.applyFilters();
  }

  AllBrandsPage.prototype.bindEvents = function () {
    var self = this;

    this.letterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        self.setLetter(button.getAttribute('data-brand-letter-filter') || 'all');
      });
    });

    document.querySelectorAll(SEARCH_SELECTOR).forEach(function (input) {
      input.addEventListener('input', function (event) {
        self.setSearch(event.target.value);
      });
    });
  };

  AllBrandsPage.prototype.setLetter = function (letter) {
    var value = letter || 'all';

    if (value !== 'all' && value === this.activeLetter) {
      value = 'all';
    }

    this.activeLetter = value;
    this.letterButtons.forEach(function (button) {
      var buttonValue = button.getAttribute('data-brand-letter-filter') || 'all';
      button.classList.toggle('is-selected', buttonValue === this.activeLetter);
    }, this);
    this.applyFilters();
  };

  AllBrandsPage.prototype.setSearch = function (query) {
    this.searchQuery = normalize(query);
    document.querySelectorAll(SEARCH_SELECTOR).forEach(function (input) {
      if (normalize(input.value) !== this.searchQuery) {
        input.value = this.searchQuery;
      }
    }, this);
    this.applyFilters();
  };

  AllBrandsPage.prototype.applyFilters = function () {
    var visibleCount = 0;

    this.cards.forEach(function (card) {
      var title = normalize(card.getAttribute('data-brand-title'));
      var letter = (card.getAttribute('data-brand-first-letter') || '').toUpperCase();
      var matchesSearch = !this.searchQuery || title.indexOf(this.searchQuery) !== -1;
      var matchesLetter = this.activeLetter === 'all' || letter === this.activeLetter;
      var visible = matchesSearch && matchesLetter;
      card.classList.toggle('is-hidden', !visible);
      if (visible) visibleCount += 1;
    }, this);

    this.groups.forEach(function (group) {
      var groupLetter = group.getAttribute('data-brand-group');
      var visibleCards = group.querySelectorAll('[data-brand-card]:not(.is-hidden)');
      var matchesLetter = this.activeLetter === 'all' || groupLetter === this.activeLetter;
      group.classList.toggle('is-hidden', !matchesLetter || visibleCards.length === 0);
    }, this);

    if (this.emptyState) {
      this.emptyState.classList.toggle('is-visible', visibleCount === 0);
    }
  };

  function initBrandsList() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      if (root.__allBrandsPage) return;
      root.__allBrandsPage = new AllBrandsPage(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBrandsList);
  } else {
    initBrandsList();
  }
})();

(function () {
  var LINE_COUNT = 5;

  function initDescription(sectionId) {
    var wrapper = document.getElementById('all-brands-desc-' + sectionId);
    var toggle = document.getElementById('all-brands-desc-toggle-' + sectionId);
    if (!wrapper || !toggle || wrapper.dataset.descReady === 'true') return;

    wrapper.dataset.descReady = 'true';

    function needsToggle() {
      wrapper.classList.remove('is-collapsed', 'is-expanded');
      wrapper.style.maxHeight = 'none';
      var lineHeight = parseFloat(window.getComputedStyle(wrapper).lineHeight) || 24;
      var maxLinesHeight = lineHeight * LINE_COUNT;
      return wrapper.scrollHeight > maxLinesHeight + 4;
    }

    function collapse() {
      wrapper.classList.remove('is-expanded');
      wrapper.classList.add('is-collapsed');
      toggle.textContent = toggle.getAttribute('data-view-more') || 'View More';
      toggle.setAttribute('aria-expanded', 'false');
    }

    function expand() {
      wrapper.classList.remove('is-collapsed');
      wrapper.classList.add('is-expanded');
      toggle.textContent = toggle.getAttribute('data-view-less') || 'View Less';
      toggle.setAttribute('aria-expanded', 'true');
    }

    function setup() {
      if (!needsToggle()) {
        wrapper.classList.add('is-expanded');
        toggle.classList.remove('is-visible');
        toggle.setAttribute('aria-expanded', 'true');
        return;
      }

      collapse();
      toggle.classList.add('is-visible');
    }

    toggle.addEventListener('click', function () {
      if (wrapper.classList.contains('is-collapsed')) {
        expand();
      } else {
        collapse();
      }
    });

    setup();
  }

  function initAllDescriptions() {
    document.querySelectorAll('[data-all-brands-description]').forEach(function (node) {
      initDescription(node.getAttribute('data-all-brands-description'));
    });
  }

  window.initAllBrandsDescription = initDescription;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllDescriptions);
  } else {
    initAllDescriptions();
  }
})();
